let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6K2Jw")).then(() => parcelRequire('dgHZQ'));